import {Scroll} from '@/utils/scroll';

const FormMessage = {
  watch: {
    message(value) {
      if (value) {
        this.$nextTick(Scroll.toPageTop);
      }
    },
  },
  computed: {
    messageIcon() {
      if (this.messageType === 'success') {
        return 'check_circle';
      } else if (this.messageType === 'alert') {
        return 'warning';
      }

      return '';
    },
  },
  methods: {
    /**
     * Hide message.
     */
    hideMessage() {
      this.message = '';
      this.messageType = '';
    },

    /**
     * Display error message.
     * @param message
     */
    displayError(message) {
      this.messageType = 'alert';
      this.message = message;
    },

    /**
     * Display success message.
     * @param message
     */
    displaySuccess(message) {
      this.messageType = 'success';
      this.message = message;
    },
  },
  data() {
    return {
      messageType: '',
      message: '',
    };
  },
};

export {FormMessage};
